import { requestApi } from '../util/network'

// 获取商品搜藏列表
export const getFavoriteGoodsList =
    (page) => requestApi(
      '/Memberfavorites/favorites_list',
      'POST',
      {
        'page': page
      },
      'member'
    )
// 删除商品搜藏
export const delFavoriteGoods =
    (favId) =>
      requestApi(
        '/Memberfavorites/favorites_del',
        'POST',
        {
          'fav_id': favId
        },
        'member'
      )
